import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { ValidationManager } from "../../../../js/lib/manager/ValidationManager";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { BaseMiniPopUpControl } from "./BaseMiniPopUpControl";
import { SimpleErrorDialog } from "./simpleErrorDialog";
import { SuccessMessageControl } from "./successMessageControl";

export class ShareControl extends BaseMiniPopUpControl {
  constructor() {
    var options = {
      id: LS2PAC_CONSTANTS.Ids.shareThisControl,
      title: ApplicationData.language.shareControlHeader,
      showHeader: true,
      openEvent: LS2PAC_CONSTANTS.Events.onOpenShareThis,
      saveEvent: LS2PAC_CONSTANTS.Events.onShareThis,
      saveResponseEvent: LS2PAC_CONSTANTS.Events.onShareThisResponse,
      template: "tmpl/controls/shareControl.html",
      allowsBlankValues: true,
      focusInputs: false,
    };

    super(options);

    this.urlOrIdToShare = null;
    this.shareType = null;

    
  }
  hasValidFormData() {
    var friendsString = $("#" + this.id + "_shareToEmails").val();
    var validEmails = true;
    var emailRegex = ValidationManager.getEmailPattern();
    $.each(friendsString.split(","), function (index, email) {
      email = email.trim();
      validEmails = emailRegex.test(email);
      if (validEmails == false) {
        return false;
      }
    });

    this.isValid = validEmails;
    if (this.isValid == false) {
      SimpleErrorDialog.show(
        ApplicationData.language.shareInvalidEmailAddresses
      );
    }

    return this.isValid;
  }
  formSubmit(event) {
    TLCEventManager.fireEvent(this.saveEvent, {
      listId: this.urlOrIdToShare,
      friends: $("#" + this.id + "_shareToEmails").val(),
      note: $("#" + this.id + "_shareMessage").val(),
      shareType: this.shareType,
    });
    return false;
  }
  addExtraListeners(_this) {
    const openGuid = TLCEventManager.addListener(this.openEvent, function (event) {
      _this.urlOrIdToShare = event.url;
      _this.shareType = event.shareType;
    });
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(this.openEvent, openGuid));

    const saveGuid = TLCEventManager.addListener(this.saveResponseEvent, function (event) {
      if (event.success) {
        SuccessMessageControl.show(event.message);
      } else {
        SimpleErrorDialog.show(event.message);
      }
    });
    this.removeListenerFunctions.push(() => TLCEventManager.removeListener(this.saveResponseEvent, saveGuid));
  }
  addEvents(_this) {
    $("#" + this.id).on(
      "click",
      "#" + this.id + "_cancelButton",
      function () {
        _this.closePopUp();
        return false;
      }
    );
  }
  removeEvents(){
    $("#" + this.id).off("click", "#" + this.id + "_cancelButton");
  }
}
